import { Navbar, Container, Button, Row, Col } from "react-bootstrap";

import logoBetrack from "../../ASSETS/images/beetrack.png";
import logoSTK from "../../ASSETS/images/logo-header.png";
import logovpnGreen from "../../ASSETS/images/vpn-green.svg";
import logovpnRed from "../../ASSETS/images/vpn-red.svg";
import { ReactChild, ReactFragment, ReactPortal, useEffect, useState } from "react";
import { Tooltip } from 'antd';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse, faGlobe, faBan } from "@fortawesome/free-solid-svg-icons";
import { useLocation } from "react-router-dom";
import { useIsOnline } from 'react-use-is-online';
import CheckVPN from "../../SHARED/Check-VPN";
import { HOME_URL } from "../../API/CONSTANTS/constants";



export default function Menu(props: any) {

  const [activo, setActivo] = useState(true);
  const [vpn, setVpn] = useState(true);


  let logo = props.logo;

  const { isOnline, isOffline, error } = useIsOnline();

  function VolverTopdesk() {
    window.open(HOME_URL.HOME, '_self', 'noopener noreferrer');
  }


  const TIEMPO_INACTIVIDAD = 120000; // 2 Minutos
  // const TIEMPO_INACTIVIDAD = 3000; // 3 segundos

  useEffect(() => {
    let timer: any;

    const manejarMovimiento = () => {
      setActivo(true); // El usuario está activo
      clearTimeout(timer); // Limpiamos el timer anterior
      // Creamos un nuevo timer
      timer = setTimeout(() => {
        setActivo(false);
        VolverTopdesk();
        console.log("Inactivo");
      }, TIEMPO_INACTIVIDAD);
    };

    // Añadir el listener del evento al montar el componente
    window.addEventListener('mousemove', manejarMovimiento);

    // Limpiar el listener y el timer al desmontar el componente
    return () => {
      window.removeEventListener('mousemove', manejarMovimiento);
      clearTimeout(timer);
    };
  }, []); // El array vacío asegura que se ejecute solo al montar/desmontar



  async function VPN() {

    let Resultado: boolean = await CheckVPN();

    // let Resultado: boolean = true;

    setVpn(Resultado);

  }

  useEffect(() => {

    const intervaloId = setInterval(() => VPN(), 6000);

    return () => {
      clearInterval(intervaloId);
    };

  }, []);



  return (
    <>
      <Navbar className="navbar " bg="dark" expand="lg">
        <Container>

          <Navbar.Brand>
            <Row className="">

              {
                (logo === "beetrack") ? (
                  <Col className="col">
                    <img alt="Beetrack" src={logoBetrack} style={{ height: "35px" }} />
                  </Col>
                ) : (
                  <Col className="col">
                    <img alt="Beetrack" src={logoSTK} style={{ height: "35px" }} />

                  </Col>
                )
              }

              <Col className="col">
                <h5 style={{ color: "white" }}>  {props.titulo} </h5>
              </Col>
            </Row>
          </Navbar.Brand>

          <Col></Col>
          <Col></Col>
          <Col>

            {
              vpn ? <>
                <Tooltip placement="bottom" title="Con Conexión a VPN">
                  <img src={logovpnGreen} style={{ height: "35px", fill: "Green" }} />
                </Tooltip>
              </>
                :
                <>
                  <Tooltip placement="bottom" title="Sin Conexión a VPN">
                    <img src={logovpnRed} style={{ height: "35px", fill: "Red" }} />
                  </Tooltip>
                </>
            }

          </Col>
          <Col>
            {
              isOnline ? <>
                <Tooltip placement="bottom" title="Con Conexión a Internet">
                  <FontAwesomeIcon icon={faGlobe} style={{ color: "Green" }} />
                </Tooltip>
              </> : <>
                <Tooltip placement="bottom" title="Sin Conexión a Internet">
                  <FontAwesomeIcon icon={faBan} style={{ color: "Red" }} />
                </Tooltip>
              </>
            }

          </Col>

          <Col>

            <Button
              variant="success"
              onClick={() => { VolverTopdesk() }}
            >
              <FontAwesomeIcon icon={faHouse} />
              {" "}
              Volver Topdesk
            </Button>

          </Col>

        </Container>

      </Navbar>
    </>
  );
}
